// @flow

import { type PendingIncomingPayment } from './types';

const SAMPLE_QR_CODE_BASE64 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';

export function getBrebQRCodeValue(incomingPayment: PendingIncomingPayment): string {
  if (ENV_CONSTANTS.ENV !== 'production') {
    return SAMPLE_QR_CODE_BASE64;
  }

  const ewallet = incomingPayment.ewallet;
  if (!ewallet || !ewallet.qr_code_value) {
    throw new Error('BreB QR code value is not available');
  }

  return ewallet.qr_code_value;
}
